import { useProjectDocumentsService, ProjectDocument } from 'nekst-api';
import { useState } from 'react';
import { useShowContextRequired } from 'ui-builder';

export function useShareDocumentButton(copyToClipboardFn: (text: string) => void) {
  const [copied, setCopied] = useState(false);
  const projectDocumentService = useProjectDocumentsService();
  const showContext = useShowContextRequired<ProjectDocument>();

  const setCopiedFunc = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const onClick = async () => {
    if (!copied) {
      const link = await projectDocumentService.getSharingUrl(showContext.data.id);
      copyToClipboardFn(link);
      setCopiedFunc();
    }
  };

  return {
    onClick,
    isGranted: !!showContext.data?.fileId,
    isCopied: copied,
  };
}
